import { sendWebsocketMessage } from '../../../../../App';

export function requestChartData({
  msgId,
  symbol,
  candleDuration,
  numberOfCandles,
  timeUnit,
  brokerage,
}) {
  const msg = {
    messageType: 'getChart',
    msgId,
    symbol,
    candleDuration,
    numberOfCandles,
    timeUnit,
    brokerage,
  };
  sendWebsocketMessage(msg);
}
